import { render, staticRenderFns } from "./invitation-table.vue?vue&type=template&id=5dc294f2&scoped=true"
import script from "./invitation-table.vue?vue&type=script&lang=js"
export * from "./invitation-table.vue?vue&type=script&lang=js"
import style0 from "./invitation-table.vue?vue&type=style&index=0&id=5dc294f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc294f2",
  null
  
)

export default component.exports